/**
 * 瓶種「參考售價區間」顯示規則（bootstrap → available_suppliers[].gas_cylinders[].price_range）。
 *
 * 由平台後台（PW）針對每間瓦斯行、每個「瓶重 × 品項」分別設定，純顯示用：
 * 不參與任何計價、對帳或金額驗證，實際下單金額一律以 unit_price 為準，
 * 也不保證 unit_price 落在 [min, max] 內（兩者分開設定）。單位為「元 / 桶」，非每公斤。
 *
 * 後端已過濾掉所有格式錯誤（非有限數字、負數、min > max）→ 一律回 null，
 * 因此前端拿到的必定是合法的 { min, max } 或 null，不需再做防禦性驗證。
 *
 * 註：不看 hide_amount_on_pending。是否顯示只由 PW 後台的 gas_price_ranges.enabled
 * 決定（後端 enabled !== true 就回 null），與「待確認隱藏金額」開關互不影響。
 */

/** 參考售價範圍，單位為「元 / 桶」（整桶價，不是每公斤）。 */
export interface GasPriceRange {
  min: number;
  max: number;
}

/**
 * 將參考售價區間格式化為顯示字串。
 * @param range bootstrap 帶回的 price_range（未設定為 null）。
 * @returns 顯示字串（min === max 時只顯示單一數字），未設定時回 null。
 */
export function formatGasPriceRange(range: GasPriceRange | null | undefined): string | null {
  if (!range) return null;
  const { min, max } = range;
  if (min === max) return `$${min.toLocaleString()}`;
  return `$${min.toLocaleString()} ~ $${max.toLocaleString()}`;
}
